export default {
  GET_CONSENTS: '@@IO_ADMIN_USER/GET_CONSENTS',
  SET_CONSENTS: '@@IO_ADMIN_USER/SET_CONSENTS',
  SET_LOADING: '@@IO_ADMIN_USER/SET_LOADING',
  SET_SLOT: '@@IO_ADMIN_USER/SET_SLOT',
  SET_ERROR: '@@IO_ADMIN_USER/SET_ERROR',
  SIGN_CONSENTS: '@@IO_ADMIN_USER/SIGN_CONSENTS',
  SET_SIGNED_CONSENTS: '@@IO_ADMIN_USER/SET_SIGNED_CONSENTS',
  REVIEW_CONSENT: '@@IO_ADMIN_USER/REVIEW_CONSENTS',
  SAVE_ADDRESS: '@@IO_ADMIN_USER/SAVE_ADDRESSS',
  UPDATE_PATIENT: '@@IO_ADMIN_USER/UPDATE_PATIENT',
  SET_PATIENT: '@@IO_ADMIN_USER/SET_PATIENT',
  SET_INSURANCE_DETAILS: '@@IO_ADMIN_USER/SET_INSURANCE_DETAILS',
  SAVE_INSURANCE_DETAILS: '@@IO_ADMIN_USER/SAVE_INSURANCE_DETAILS',
  VALIDATE_ZIP_CODE: '@@IO_ADMIN_USER/VALIDATE_ZIP_CODE',
  GET_INSURANCE_SKIP_FLAG: '@@IO_ADMIN_USER/GET_INSURANCE_SKIP_FLAG',
};
